<template>
    <div id="chart"></div>
</template>

<style>
.svg-container {
  /* display: inline-block;
  position: relative; */
  width: 100%;
  padding-top: 0%;
  vertical-align: top;
  /* height: 600px; */
  /* overflow: hidden; */
}
.svg-content-responsive {
  /* display: inline-block;
  position: absolute; */
  /* top: 10px; */
  left: 0;
}

</style>

<script>
import * as d3 from "d3";
import { mapGetters, mapActions, mapMutations } from "vuex";
import countries from "@/assets/countries.js";

export default {
  name: "bar-chart",
  props: ['data'],
  data() {
    return {
      chart: null,
      tooltip: null
    };
  },
  mounted(){
    this.tooltip = d3.select("body")
    	.append("div")
    	.style("position", "absolute")
    	.style("z-index", "10")
    	.style("visibility", "hidden")
      .style("background", "white")
      .style("font-size", "12px")
      .style("padding", "4px")
      .style("box-shadow", "1px 1px 4px black")
      .style("border-radius", "2px")
    	.text("Click to view these investors in the directory")
    this.renderChart()
  },
  computed: {
    ...mapGetters({
      selectedDataSectors: 'selectedDataSectors',
      selectedDataProviderTypes: 'selectedDataProviderTypes',
      selectedDataCapitalTypes: 'selectedDataCapitalTypes',
      devCountries: 'devCountries'
    }),
    noResults: function(){
      return this.data.length == 0
    }
  },
  watch:{
    data(a){
      this.clearChart()
      this.renderChart()
    }
  },
  methods: {
    ...mapMutations([
      'setCapitalTypesParam',
      'setProviderTypesParam',
      'setCountriesParam',
      'setSectorsParam',
      'toggleCapitalTypesParam',
      'toggleProviderTypesParam',
      'toggleCountriesParam',
      'toggleSectorsParam'
    ]),
    ...mapActions({
      search: "search"
    }),
    isDeveloping(country){
      return this.devCountries.some(item=>item.name == country.country)
    },
    toCountry(country){
      var vm = this
      function goToCountry(country){
        if (vm.isDeveloping(country)) {
          vm.tooltip.style("visibility", "hidden");
          vm.setSectorsParam()
          vm.setProviderTypesParam()
          vm.setCapitalTypesParam()
          vm.setCountriesParam({code: countries[country.country]})

          vm.selectedDataSectors
          .forEach((item)=>vm.toggleSectorsParam(item))

          vm.selectedDataProviderTypes
          .forEach((item)=>vm.toggleProviderTypesParam(item))

          vm.selectedDataCapitalTypes
          .forEach((item)=>vm.toggleCapitalTypesParam(item))

          var timeBefore = performance.now();
          vm.search().then();
          vm.$router.push({ name: 'Directory' })
        }
        // this.setCountriesParam(data=this.dataSectorSelected)
      }
      return goToCountry
    },
    clearChart(){
      d3.selectAll("#chart > *").remove();
    },
    renderChart() {
      const margin = 60;
      var svg_width = 1100;
      const svg_height = 420;
      const chart_width = svg_width - 2 * margin;
      const chart_height = svg_height - 2 * margin;

      const svg = d3
        .select('#chart')
        .append("div")
        // Container class to make it responsive.
        .classed("svg-container", true)
        // .attr("height", svg_height)
        .append("svg")

      if (window.innerWidth < 1000) {
        svg
          // Responsive SVG needs these 2 attributes and no width and height attr.
          .attr("preserveAspectRatio", "xMinYMin meet")
          .attr("viewBox", "0 0 1150 560")
          // Class to make it responsive.
          .classed("svg-content-responsive", true)
          .append("svg")
          .attr("width", svg_width)
          .attr("height", svg_height)
        this.chart = svg
          .append("g")
          .attr("transform", `translate(${margin}, ${margin})`);
      } else if (window.innerWidth > 1000 && window.innerWidth < 1090) {
        svg_width= 800
        svg
          .classed("svg-content-responsive", true)
          .attr("viewBox", "0 0 1150 560")
          .attr("width", svg_width)
          .attr("height", svg_height)
        this.chart = svg
          .append("g")
          .attr("transform", `translate(${0}, ${100})`);
      } else if (window.innerWidth > 1090) {
        svg
          .classed("svg-content-responsive", true)
          .attr("viewBox", "0 0 1150 560")
          .attr("width", svg_width)
          .attr("height", svg_height)
        this.chart = svg
          .append("g")
          .attr("transform", `translate(${-50}, ${100})`);
      }

        // Fill with a rectangle for visualization.

      // const svg = d3
      //   .select("svg")
      //   .attr("width", svg_width)
      //   .attr("height", svg_height);


      if (this.noResults){
        this.chart.append("text")
          .attr("x", function(d) { return + 100; })
          .attr("y", chart_height / 2)
          .text(function(d) { return 'No results, Please broaden your search parameters.'; });
      }

      const yScale = d3
        .scaleLinear()
        .range([chart_height, 0])
        .domain([0, Math.max(...this.data.map(d=>d.val))]);

      function formatTick(d) {
        return this.parentNode.nextSibling ? `\xa0${d}` : `${d}`;
      }

      this.chart
        .append("g")
        .call(d3.axisLeft(yScale)
              // .ticks(Math.max(...this.data.map(d=>d.val)))
              .ticks(4)
              .tickSize(-chart_width)
              .tickFormat(formatTick))
        .call(g => g.selectAll(".tick:not(:first-of-type) line")
              .attr("stroke-opacity", 0.3))

      const xScale = d3
        .scaleBand()
        .range([0, chart_width])
        .domain(this.data.map(s => s.country))
        .padding(0.2);

      this.chart
        .append("g")
        .attr("transform", `translate(0, ${chart_height})`)
        .call(d3.axisBottom(xScale))
        .call(g => g.selectAll(".tick text")
          .attr("font-size", 12))

      if (window.innerWidth < 400) {
        this.chart.call(g => g.selectAll(".tick text")
          .attr("font-size", 22))
      }

      const barGroups = this.chart
        .selectAll('rect')
        .data(this.data)
        .enter()

      var tooltip = this.tooltip
      var vm = this

      function handleMouseOver(d, i) {
        if (vm.isDeveloping(d)) {
          d3.select(this).attr('opacity', 1);
          tooltip.style("visibility", "visible");
        }
      }

      function handleMouseOut(d, i) {
        d3.select(this).attr('opacity', 0.7);
        tooltip.style("visibility", "hidden");
      }


      barGroups
        .append('rect')
        .attr('class', 'bar')
        .on("click", this.toCountry())
        .on("mouseover", handleMouseOver)
        .on("mousemove", function(){return tooltip.style("top", (event.pageY-10)+"px").style("left",(event.pageX+10)+"px");})
        .on("mouseout", handleMouseOut)
        .attr('x', (g) => xScale(g.country))
        .attr('y', (g) => yScale(g.val))
        .attr('height', (g) => chart_height - yScale(g.val))
        .attr('width', xScale.bandwidth())
        .attr('fill', (g)=>g.color)
        .attr('opacity', 0.7);
    }
  }
};
</script>



// WEBPACK FOOTER //
// src/elements/charts/BarChart.vue